import React from "react";
import { Link, useParams } from "react-router-dom";
import { Icon, Menu } from "semantic-ui-react";
import usePageData from "../../state-manipulation/hooks/usePageData";
import useUserData from "../../state-manipulation/hooks/useUserData";
import IsAuthorized from "../common/IsAuthorized";

export default function CashAndPaymentsMenu({ onClick }) {
  let { company } = useParams();
  const [pageData] = usePageData();
  const [userData, userDispatch] = useUserData();

  if (!company) {
    company = userData.orgs[0].name.toLowerCase();
  }

  return (
    <IsAuthorized permission="hasCashPayments">
      <Menu.Item>
        <Menu.Header>Cash &amp; Payments</Menu.Header>
        <Menu.Menu>
          <IsAuthorized permission="hasCashPaymentsCashCount">
            <Menu.Item
              as={Link}
              to={"/" + company + "/cash-count"}
              onClick={onClick}
              active={
                pageData.selectedPage.toUpperCase() === "CASH COUNT"
                  ? true
                  : false
              }
            >
              <Icon name="currency" />
              Cash Count
            </Menu.Item>
          </IsAuthorized>
          <IsAuthorized permission="hasCashPaymentsPOSCashTransactions">
            <Menu.Item
              as={Link}
              to={"/" + company + "/cash-transactions"}
              onClick={onClick}
              active={
                pageData.selectedPage.toUpperCase() === "POS CASH TRANSACTIONS"
                  ? true
                  : false
              }
            >
              <Icon name="currency" />
              POS Cash Transactions
            </Menu.Item>
          </IsAuthorized>
          <IsAuthorized permission="hasCashPaymentsPrintChecks">
            <Menu.Item
              as={Link}
              to={"/" + company + "/print-checks"}
              onClick={onClick}
              active={
                pageData.selectedPage.toUpperCase() === "PRINT CHECKS"
                  ? true
                  : false
              }
            >
              <Icon name="print" />
              Print Checks
            </Menu.Item>
          </IsAuthorized>
          <IsAuthorized permission="hasCashPaymentsAddPayments">
            <Menu.Item
              as={Link}
              to={"/" + company + "/add-payments"}
              onClick={onClick}
              active={
                pageData.selectedPage.toUpperCase() === "ADD PAYMENTS"
                  ? true
                  : false
              }
            >
              <Icon name="pencil" />
              Add Payments
            </Menu.Item>
          </IsAuthorized>
          <IsAuthorized permission="hasCashPaymentsViewPayments">
            <Menu.Item
              as={Link}
              to={"/" + company + "/admin/payments"}
              onClick={onClick}
              active={
                pageData.selectedPage.toUpperCase() === "PAYMENTS"
                  ? true
                  : false
              }
            >
              <Icon name="eye" />
              View Payments
            </Menu.Item>
          </IsAuthorized>
          <IsAuthorized permission="hasCashPaymentsManageVendors">
            <Menu.Item
              as={Link}
              to={"/" + company + "/admin/vendors"}
              onClick={onClick}
              active={
                pageData.selectedPage.toUpperCase() === "VENDORS" ? true : false
              }
            >
              <Icon name="address book" />
              Vendors
            </Menu.Item>
          </IsAuthorized>
        </Menu.Menu>
      </Menu.Item>
    </IsAuthorized>
  );
}
